<template>
  <div
  v-if="getLoadingStatus"
    class="loading-state"
  >
    <div
      class="spinner"
    >
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    getLoadingStatus () {
      return this.$store.getters['spinner/getLoadingStatus']
    }
  },
};
</script>

<style lang="scss">
  @import './styles.scss';
</style>
